export const atom = {
  meta: {
    name: 'Atom'
  },
  layout: {
    content: {
      border: {
        left: '1px solid var(--border-color)'
      },
      boxShadow: '0'
    }
  },
  sidebar: {
    background: {
      color: 'var(--color-white)'
    },
    box: {
      shadow: 'inset 0 -15px 0 0 var(--color-gray-0)'
    },
    divider: {
      color: 'var(--border-color)'
    },
    header: {
      border: {
        bottom: '1px solid var(--sidebar-divider-color)'
      },
      height: '110px',
      imageBackground: 'url(https://opensense.s3.amazonaws.com/logo-horizontal.svg) no-repeat center center',

      badge: {
        backgroundColor: 'var(--border-color)',
        color: 'var(--color-gray-700)'
      }
    },

    section: {
      heading: {
        color: {
          _: 'var(--color-gray-600)',
          hover: 'var(--color-gray-900)',
          active: 'var(--color-gray-900)'
        },
        toggle: {
          icon: {
            color: {
              active: 'var(--color-gray-800)'
            }
          }
        },
        icon: {
          background: {
            color: {
              active: 'var(--color-blue-400)'
            }
          },
          color: {
            _: 'var(--color-gray-900)',
            active: 'var(--color-white)'
          }
        }
      },
      items: {
        border: {
          left: '2px solid var(--color-gray-300)'
        },
        active: {
          item: {
            color: 'var(--color-gray-900)'
          }
        }
      },
      item: {
        backgroundColor: {
          hover: 'var(--color-gray-100)'
        },
        color: {
          _: 'var(--color-gray-600)',
          hover: 'var(--color-gray-900)',
          active: 'var(--color-white)'
        }
      }
    },
    user: {
      background: {
        color: 'var(--color-gray-0)'
      },
      name: {
        color: 'var(--color-gray-900)'
      },
      trigger: {
        backgroundColor: 'var(--color-gray-100)',
        color: 'var(--color-gray-600)'
      }
    }
  }
};
